import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type TopbarContextType = {
    id?: string;
};

const TopbarContext = createContext<TopbarContextType>({});
const TopbarUpdateContext = createContext<(id: string) => void>(() => { });

export const useTopbarId = () => useContext(TopbarContext);
export const useSetTopbarId = () => useContext(TopbarUpdateContext);

export const TopBarProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const [id, setId] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (location.state?.id) {
            setId(location.state.id);
        }
    }, [location.state?.id]);

    const contextValue = useMemo(() => ({ id }), [id]);

    return (
        <TopbarContext.Provider value={contextValue}>
            <TopbarUpdateContext.Provider value={setId}>
                {children}
            </TopbarUpdateContext.Provider>
        </TopbarContext.Provider>
    );
};
